<template>
    <flex-layout styleClasses="p-24">
        <TableQuery :params="params" :sorts="sorts" :resetFilters="resetFilters" :sortBy="sortBy" />

        <div class="position-relative h-100">
            <absolute-layout :scrollable="true" styleClass="table-responsive">
                <table class="table table-01" width="50%">
                    <thead>
                        <th v-for="item in tableHeading" :key="item.index">
                            {{ item.heading }}
                        </th>

                        <th>Actions</th>
                    </thead>
                    <Spinner v-if="isLoading" />
                    <TableData :tableData="tableData" v-else>
                        <tr v-for="item in tableData" :key="item.index">

                            <td>
                                {{ item.boid }}
                            </td>
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.email }}
                            </td>
                            <td>
                                {{ item.contact_number }}
                            </td>
                            <td>
                                {{ item.created_on }}
                            </td>
                            <td>
                                {{ item.renewed_on }}
                            </td>
                            <td>
                                {{ item.expires_on }}
                            </td>

                            <td class="action">
                                <button title="Retry" class="btn btn-sm btn-gray"
                                    @click.prevent="notifyExpiredIndividual(item.id)"
                                    v-if="$can($route.meta.guard + '.create')">
                                    <i class="ic-email"></i>
                                </button>
                            </td>
                        </tr>
                    </TableData>
                </table>
                <div class="table-footer">
                    <PerPage :options="options" :params="params" />
                    <paginate :page-class="'page-item'" :page-count="pageCount" :page-link-class="'page-link'"
                        :container-class="'pagination  pagination-sm'" :prev-text="`<i class='ic-chevron-left'></i>`"
                        :next-text="` <i class='ic-chevron-right'></i>`" :prev-class="'page-link pagination-arrow mr-2'"
                        :next-class="'page-link pagination-arrow ml-2'" :click-handler="handlePagination" ref="paginate">
                    </paginate>
                </div>
            </absolute-layout>
        </div>

    </flex-layout>
</template>
  

<script>
import AbsoluteLayout from "@/components/Layout/AbsoluteLayout.vue";
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import TableMixin from "@/mixins/table.vue";
import Spinner from "@/components/Utility/Spinner.vue";
import PaginationMixin from "@/mixins/pagination.vue";
import PerPage from "@/components/Utility/PerPage.vue";
import TableQuery from "@/components/Utility/TableQuery.vue";
import TableData from "@/components/Utility/TableData.vue";
import Permissions from "@/mixins/Permissions.vue";

export default {
    name: 'ExpiredDematUserTable',
    components: {
        AbsoluteLayout, FlexLayout, PerPage,
        Spinner, TableQuery, TableData
    },
    mixins: [TableMixin, PaginationMixin, Permissions],

    data() {
        return {
            api_url: process.env.VUE_APP_API_URL,
            url: 'demat-user/getExpiredUsers',
            fetch_module: 'FETCH_EXPIRED_DEMAT_USER',
        };
    },
    methods: {

        notifyExpiredIndividual(id) {
            let uri = this.api_url + 'demat-user/notifyExpiredIndividual';
            let data = {
                id: id
            }

            this.axios.post(uri, data).then((response) => {
                this.$toast.success(response.data.message, {
                    position: "bottom-right",
                });

            });
        }
    },

};
</script>
<style scoped></style>
